//
import React, { CSSProperties } from 'react';
import { Dialog, Portal } from 'react-native-paper';
import { MAX_WIDTH_MODAL } from '../../constants';

import { Dimensions, ViewStyle } from 'react-native';
const DEVICE_WIDTH = Dimensions.get('window').width;
const DEVICE_HEIGHT = Dimensions.get('window').height;

type Props = {
  mostrarModal?: boolean;
  onClose: () => void;
  style?: ViewStyle;
};

const CModal: React.FC<Props> = (props) => {
  const { mostrarModal, onClose, children, style } = props;

  return (
    <Portal>
      <Dialog
        visible={mostrarModal}
        onDismiss={() => onClose()}
        style={[
          {
            width: Math.min(DEVICE_WIDTH * 0.9, 600),
            alignSelf: 'center',
            maxHeight: DEVICE_HEIGHT * 0.8
          },
          style
        ]}
      >
        {children}
      </Dialog>
    </Portal>
  );
};

export default CModal;
